<template>
<div class="agent-loader">
  <div class="agent-loader-container">
    <h2 class="ut-mb-12">Creating agent shortlist</h2>

    <div class="agentsbox">

      <div class="bordereffect">
      </div>

      <ul class="loader-agent-imgs" v-bind:class="{ start: started }">
        <li v-for="(agent, index) in agents" v-bind:key="agent.AgentId">
          <div v-bind:class="`agent-img-${index}`" v-bind:style="{backgroundImage: 'url(' + agent.AgentImageLink + ')' }"></div>
        </li>
        <li v-for="(n, index) in 10">
          <div v-bind:class="`agent-img-${index}`"></div>
          <div v-bind:class="`agent-img-${index}`"></div>
        </li>
        <li v-for="(n, index) in 10">
          <div v-bind:class="`agent-img-${index}`"></div>
          <div v-bind:class="`agent-img-${index}`"></div>
        </li>
      </ul>

    </div>

    <div class="ticks-box">

      <transition enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
        <div class="ticks" v-if="showTick1">
          <transition enter-active-class="animated zoomIn faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
            <svg-icon v-if="showTicka" class="svgicon" :icon="'icon-check'" :size="20" :addClass="'ut-text-Gnew'"></svg-icon>
          </transition>
          <span class="ut-ml-8">Recently sold properties</span>
        </div>
      </transition>

      <transition enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
        <div class="ticks" v-if="showTick2">
          <transition enter-active-class="animated zoomIn faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
            <svg-icon v-if="showTickb" class="svgicon" :icon="'icon-check'" :size="20" :addClass="'ut-text-Gnew'"></svg-icon>
          </transition>
          <span class="ut-ml-8">Most sales in {{postcodeData.suburb}}</span>
        </div>
      </transition>

      <transition enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
        <div class="ticks" v-if="showTick3">
          <transition enter-active-class="animated zoomIn faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="800">
            <svg-icon v-if="showTickc" class="svgicon" :icon="'icon-check'" :size="20" :addClass="'ut-text-Gnew'"></svg-icon>
          </transition>
          <span class="ut-ml-8">Independent customer reviews</span>
        </div>
      </transition>
    </div>

  </div>

</div>
</template>

<script>
import axios from 'axios';
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'AgentLoader',
  components: {
    SvgIcon,
  },
  props: {
    postcodeData: null,
    agents: null,
  },
  data() {
    return {
      started: true,
      showTick1: false,
      showTick2: false,
      showTick3: false,
      showTicka: false,
      showTickb: false,
      showTickc: false,
    };
  },
  methods: {},
  created() {
    setTimeout(() => {
      this.showTick1 = true;
    }, 500);

    setTimeout(() => {
      this.showTicka = true;
    }, 1000);

    setTimeout(() => {
      this.showTick2 = true;
    }, 2000);

    setTimeout(() => {
      this.showTickb = true;
    }, 2500);

    setTimeout(() => {
      this.showTick3 = true;
    }, 3500);

    setTimeout(() => {
      this.showTickc = true;
    }, 4000);

  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.agent-loader {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: #fff;

    @screen sm {
        z-index: 2;
    }

    .agent-loader-container {
        margin: 0 20px;
        overflow: hidden;
        margin: calc(50vh - 250px) 20px 0;
        max-width: 366px;

        @screen sm {
            max-width: 565px;
            margin: calc(50vh - 250px) auto 0;
        }

        h2 {
            text-align: left;
            font-size: 28px;
            font-weight: 600;
            letter-spacing: -0.5px;
            line-height: 36px;
            max-width: 220px;
            margin-left: 0;

            @screen sm {
                margin-left: auto;
                max-width: 100%;
                text-align: center;
                font-size: 36px;
                font-weight: 600;
                letter-spacing: -0.64px;
                line-height: 36px;
            }
        }
    }
    .ticks-box {
        margin-top: 50px;
        min-height: 200px;
        .ticks {
            margin-top: 25px;
            width: 320px;
            color: #545352;
            font-size: 20px;
            line-height: 28px;
        }
        .svgicon {
            position: absolute;
            margin-top: 5px;
        }
    }
}

.agentsbox {
    position: relative;
    .bordereffect {
        background: linear-gradient(90deg, rgba(255,255,255,0) 70%, rgba(255,255,255,1) 100%), linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 30%);

        z-index: 1;
        position: absolute;
        height: 65px;
        width: 100%;
    }
}

.loader-agent-imgs {
    margin: 19px auto 25px;
    height: auto;
    width: auto;
    text-align: center;
    animation: moveSlideshow 8s linear infinite;
    width: max-content;

    @media (min-width: 768px) {
        margin: 22px auto 30px;
    }

    li {
        display: inline-block;
        padding: 0;
        margin: auto;
        width: 46px;
        height: 46px;
        border: 2px solid #FFFFFF;
        overflow: hidden;
        border-radius: 50%;
        text-align: center;
        position: relative;

        @media (min-width: 768px) {
            width: 60px;
            height: 60px;
        }

        div {
            overflow: hidden;
            position: absolute;
            border-radius: 50%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            background-size: cover;
            opacity: 0;
            -moz-transition: all 500ms ease-in;
            -webkit-transition: all 500ms ease-in;
            transition: all 500ms ease-in;
            z-index: 0;
        }
    }

    .agent-img-0 {
        background-image: url("https://cdn.openagent.com.au//img/agent/F9E0E1791CACDAADB6B12AA8039FED96.jpg");
    }
    .agent-img-1 {
        background-image: url("https://cdn.openagent.com.au//img/agent/5FD90EB08015C8500FAE5A0FD23A0B91.jpg");
    }
    .agent-img-2 {
        background-image: url("https://cdn.openagent.com.au//img/agent/B8C946AAC1008A3B546B8BAFA994903B.jpg");
    }
    .agent-img-3 {
        background-image: url("https://cdn.openagent.com.au//img/agent/AD0ACBA910CF2C776067C95C9FB098B6.jpg");
    }
    .agent-img-4 {
        background-image: url("https://cdn.openagent.com.au//img/agent/C91CE2EA2B5629BEFA8AFA99E845058B.jpg");
    }
    .agent-img-5 {
        background-image: url("https://cdn.openagent.com.au//img/agent/945D81F7A835B50920058B7839198D4A.jpg");
    }
    .agent-img-6 {
        background-image: url("https://cdn.openagent.com.au/img/agent/1BADF555F3471C50F25EE674175DFFBE.jpg");
    }
    .agent-img-7 {
        background-image: url("https://cdn.openagent.com.au//img/agent/5FD90EB08015C8500FAE5A0FD23A0B91.jpg");
    }
    .agent-img-8 {
        background-image: url("https://cdn.openagent.com.au//img/agent/9CCC8DC27586EBBC72476C460B2A97F4.jpg");
    }
    .agent-img-9 {
        background-image: url("https://cdn.openagent.com.au//img/agent/03808189D321EA59183A5DC840CC3299.jpg");
    }
    .agent-img-10 {
        background-image: url("https://cdn.openagent.com.au//img/agent/F9E0E1791CACDAADB6B12AA8039FED96.jpg");
    }
    .agent-img-11 {
        background-image: url("https://cdn.openagent.com.au//img/agent/5FD90EB08015C8500FAE5A0FD23A0B91.jpg");
    }
    .agent-img-12 {
        background-image: url("https://cdn.openagent.com.au//img/agent/B8C946AAC1008A3B546B8BAFA994903B.jpg");
    }
    .agent-img-13 {
        background-image: url("https://cdn.openagent.com.au//img/agent/AD0ACBA910CF2C776067C95C9FB098B6.jpg");
    }
    .agent-img-14 {
        background-image: url("https://cdn.openagent.com.au//img/agent/C91CE2EA2B5629BEFA8AFA99E845058B.jpg");
    }
    .agent-img-15 {
        background-image: url("https://cdn.openagent.com.au//img/agent/945D81F7A835B50920058B7839198D4A.jpg");
    }
    .agent-img-16 {
        background-image: url("https://cdn.openagent.com.au/img/agent/1BADF555F3471C50F25EE674175DFFBE.jpg");
    }
    .agent-img-17 {
        background-image: url("https://cdn.openagent.com.au//img/agent/5FD90EB08015C8500FAE5A0FD23A0B91.jpg");
    }
    .agent-img-18 {
        background-image: url("https://cdn.openagent.com.au//img/agent/9CCC8DC27586EBBC72476C460B2A97F4.jpg");
    }
    .agent-img-19 {
        background-image: url("https://cdn.openagent.com.au//img/agent/03808189D321EA59183A5DC840CC3299.jpg");
    }

    &.start {

        li {
            overflow: hidden;

            .agent-img-0 {
                opacity: 1;
            }

            .agent-img-2 {
                transition-delay: 400ms;
                opacity: 1;
            }

            .agent-img-4 {
                transition-delay: 700ms;
                opacity: 1;
            }

            .agent-img-6 {
                transition-delay: 1200ms;
                opacity: 1;
            }

            .agent-img-8 {
                transition-delay: 1600ms;
                opacity: 1;
            }

            .agent-img-3 {
                transition-delay: 1800ms;
                opacity: 1;
            }

            .agent-img-7 {
                transition-delay: 2200ms;
                opacity: 1;
            }

            .agent-img-1 {
                transition-delay: 2600ms;
                opacity: 1;
            }

            .agent-img-9 {
                transition-delay: 3000ms;
                opacity: 1;
            }

            .agent-img-5 {
                transition-delay: 3800ms;
                opacity: 1;
            }

        }
    }
}

@keyframes moveSlideshow {
    100% {
        transform: translateX(-40.6666%);
    }
}
</style>
